import React, { createContext, useContext, useState, useCallback } from 'react';
import LinkDialog from './theme/LinkDialog';
import * as EditorTypeAll from './tinymce.d';

interface LinkManagerContextType {
  openLinkDialog: (editorInstance: EditorTypeAll.Editor) => void;
}

const LinkManagerContext = createContext<LinkManagerContextType | null>(null);

export const useLinkManager = () => {
  const context = useContext(LinkManagerContext);
  if (!context) {
    throw new Error('useLinkManager must be used within a LinkManagerProvider');
  }
  return context;
};

interface LinkManagerProviderProps {
  children: React.ReactNode;
}

export const LinkManagerProvider: React.FC<LinkManagerProviderProps> = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentEditor, setCurrentEditor] = useState<EditorTypeAll.Editor | null>(null);

  const openLinkDialog = useCallback((editorInstance: EditorTypeAll.Editor) => {
    setCurrentEditor(editorInstance);
    setDialogOpen(true);
  }, []);

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false);
    setCurrentEditor(null);
  }, []);

  return (
    <LinkManagerContext.Provider value={{ openLinkDialog }}>
      {children}
      {currentEditor && (
        <LinkDialog
          editorInstance={currentEditor}
          open={dialogOpen}
          onOpenChange={handleDialogClose}
        />
      )}
    </LinkManagerContext.Provider>
  );
};

